module.exports = (file) => require(`../views/${file}.vue`).default; // vue-loader v13.0.0+
